import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";

import { selectSearchText } from "../../../store/supervisorRequiredDocuments/selectors/selectSearchText";
import { fetchHojasDeCargo } from "../../../store/supervisorRequiredDocuments/actions/getHojasDeCargo";
import { setSearchText } from "../../../store/supervisorRequiredDocuments";

export const DocumentSearchbar: React.FC = () => {
  const dispatch = useDispatch();
  const value = useSelector(selectSearchText);
  return (
    <IonSearchbar
      value={value}
      onIonChange={({ detail: { value = "" } }) => {
        dispatch(setSearchText(value));
        dispatch(fetchHojasDeCargo());
      }}
      debounce={700}
      placeholder={"Buscar Hoja de Cargo"}
    />
  );
};
